import { errorMessage } from './feedback';
import { ApiError } from '@app/core/http';

export function Loading() {
  return <div className="stg theme-dark is-fs stg--app app-boot" aria-busy="true"><img className="app-boot__mark" src="/brand/app-mark.svg" width={40} height={40} alt="Ride N Repair OS" /><span className="stg-dots"><i /><i /><i /></span></div>;
}

/** API/Postgres down on boot (scenario S7.1): honest full-page state with the request ref and a retry. */
export function Fatal({ error, retry }: { error: unknown; retry: () => void }) {
  return (
    <div className="stg theme-dark is-fs stg--app app-boot" role="alert">
      <h1>We can't reach Ride N Repair OS right now</h1>
      <p className="stg-muted">{errorMessage(error)}{error instanceof ApiError && error.ref ? ` · ${error.ref}` : ''}</p>
      <button type="button" className="btn btn--ink btn--sm" onClick={retry}>Try again</button>
    </div>
  );
}
